import {Component} from '@angular/core';

@Component({
    selector:'app-planoinstituido',
    templateUrl: './planoinstituido.component.html',
    styleUrls:['./planoinstituido.component.scss']
})

export class planoinstituidoComponent{}